import template from './utilities-terms.jade';
import { locationPathChanged } from '../../../../blocks/segments/address/address.events';
import { ERegions } from '../../../../../../shared/constants';

// всегда включены для Москвы, МО
// Для СПБ и ЛО зависит от фича тогла addForm.UtilitiesTerms.Enabled
export const getIncludedLocationIds = isExcludeUtilitiesTermsEnabled => {
  let locationIds = [ERegions.moscow, ERegions.moscowRegion];

  if (!isExcludeUtilitiesTermsEnabled) {
    const spbLocations = [ERegions.spb, ERegions.spbRegion];
    locationIds = [...locationIds, ...spbLocations];
  }

  return locationIds;
};

export default angular
  .module('cian.addForm.bargainTermsUtilitiesTerms', [
    'cian.addForm.helperPriceCurrencyText',
    'cian.addForm.helperPriceCurrencySelect',
  ])
  .directive('cianAfPriceAndDealTermsUtilitiesTerms', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(
      $scope,
      isSimpleFormEnabled,
      excludeUtilitiesTermsRegionsService,
      geoService,
    ) {
      'ngInject';

      const { isUtilitiesTermsNotRequiredInRegion, isFeatureToggleEnabled } = excludeUtilitiesTermsRegionsService;

      this.ad.bargainTerms = this.ad.bargainTerms || {};
      this.ad.bargainTerms.utilitiesTerms = this.ad.bargainTerms.utilitiesTerms || {};
      this.isUtilitiesTermsNotRequiredInRegion = isUtilitiesTermsNotRequiredInRegion();

      const setRequireUtilitiesInRegionFlag = () => {
        this.isUtilitiesTermsNotRequiredInRegion = isUtilitiesTermsNotRequiredInRegion();
      };

      $scope.$on(locationPathChanged, setRequireUtilitiesInRegionFlag);

      this.isFieldVisible = () => {
        const locationPath = geoService.getLocationPath() || [];
        const locationId = locationPath[locationPath.length - 1];
        const includedLocationIds = getIncludedLocationIds(isFeatureToggleEnabled);

        return !isSimpleFormEnabled() || !includedLocationIds.includes(locationId);
      };
    },
    controllerAs: 'utilitiesTerms',
    template,
  }))
  .name;
